import styled from "styled-components";
import {borderColor} from "../colors";

export const FullWidth = styled.div`
  width: 100%;
`;

export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 60px;
  
  @media only screen and (max-width: 767px) {
     padding: 30px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ActionButtonsRow = styled(Row)<{containsOneItem?: boolean}>`
  justify-content: ${({containsOneItem}) => containsOneItem ? 'flex-end' : 'space-between'};
  width: 100%;
  margin-top: 40px;
  
  @media only screen and (max-width: 767px) {
     margin-top: 20px;
  }
`;

export const SingleActionButtonRow = styled(ActionButtonsRow)`
  justify-content: flex-start;
  margin-top: 15px;
`;

export const Separator = styled.div`
  position: relative;
  width: 100%;
  height: 1px;
  background-color: ${borderColor};
`;

export const List = styled.ul`
  margin-top: 0;
`;